import { FC, useEffect } from "react";
import close from "../../images/close.svg";

const ErrorModal: FC<ErrorModalProps> = ({
  onAccept,
  onClose,
  errorTitle,
  errorDescription,
  btnTxt,
}) => {
  useEffect(() => {
    const handleEscapeKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEscapeKey);

    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [onClose]);

  return (
    <div className="relative flex flex-col items-center text-center text-gray-7 bg-white rounded-[20px] py-[93.5px] px-[92.5px] w-[calc(100%-48px)] max-w-[420px] xs:px-[35.5px] sm:w-[490px] sm:max-w-[490px]">
      <img
        className="absolute top-8 right-[26px] cursor-pointer"
        src={close}
        alt="close"
        onClick={onClose}
      />

      <h1 className="font-extrabold text-[32px] leading-[38px] mb-4 xs:text-[50px] xs:leading-[52px] xs:mb-10">
        {errorTitle || "Oh No!"}
      </h1>
      <p className="font-[400] text-[14px] leading-[18px] xs:text-base xs:leading-[20px] mb-10">
        {errorDescription}
      </p>
      <button
        className="bg-gray-7 text-white font-[900] rounded-[24px] py-[15px] max-w-[calc(100%-64px)] w-[305px] text-base leading-[20px] xs:text-[18px] xs:leading-[22px]"
        onClick={onAccept}
      >
        {btnTxt || "Try Again"}
      </button>
    </div>
  );
};

export default ErrorModal;

interface ErrorModalProps {
  onAccept: () => void;
  onClose: () => void;
  errorDescription?: string;
  errorTitle?: string;
  btnTxt?: string;
}
